import { useState } from "react"

import DefaultBoundaries from "@/app/boundaries/DefaultBoundaries"
import { MenuAppInstance } from "@/entities/app/menu/menu.types"
import { Design } from "@/entities/design"
import Button from "@/shared/components/intrinsic/Button/Button"

import MenuDesignSelector from "../../components/MenuDesignSelector/MenuDesignSelector"

interface Step2DesignSelectionProps {
  app: MenuAppInstance
  selectedDesign: Design | null
  onChange: (design: Design | null) => void
}

function Step2DesignSelection(props: Step2DesignSelectionProps) {
  const [refreshFn, setRefreshFn] = useState<(() => Promise<void>) | null>(null)

  const handleRefresh = async () => {
    if (refreshFn) {
      await refreshFn()
    }
  }

  return (
    <div className="step2-design-selection">
      <div className="step2-design-selection__header">
        <label className="step2-design-selection__label">
          Choose Design
          <span className="step2-design-selection__hint">
            Upload the design wanted to display when this scheduler is active*
          </span>
        </label>
        <Button
          color="green"
          size="small"
          await={true}
          onClick={handleRefresh}
        >
          Refresh
        </Button>
      </div>
      <DefaultBoundaries>
        <MenuDesignSelector
          app={props.app}
          current={props.selectedDesign}
          onChange={props.onChange}
          onRefreshReady={(fn) => setRefreshFn(() => fn)}
        />
      </DefaultBoundaries>
    </div>
  )
}

export default Step2DesignSelection
